'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
var _reactI18next = require('react-i18next');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  blockContainer: {
    backgroundColor: '#e0e0e0',
    color: '#676767',
    minHeight: function minHeight(_ref) {
      var editable = _ref.editable;
      return editable ? '3rem' : '0rem';
    },
    heigth: function heigth(_ref2) {
      var editable = _ref2.editable;
      return editable ? 'auto' : '0rem';
    },
    padding: function padding(_ref3) {
      var editable = _ref3.editable;
      return editable ? '1rem' : '0';
    }
  },
  modalCookie: {
    position: 'fixed',
    bottom: '0',
    zIndex: '1030',
    width: function width(_ref4) {
      var responsiveMode = _ref4.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '50%' : '100%';
    },
    padding: '1rem',
    margin: function margin(_ref5) {
      var responsiveMode = _ref5.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '1rem' : '0';
    }
  },
  infoCookies: {
    margin: '0 0 1rem 0',
    width: '90%'
  },
  button: {
    fontFamily: 'inherit',
    borderRadius: '0',
    marginRight: '16px',
    backgroundColor: function backgroundColor(_ref6) {
      var buttonColor = _ref6.otherProperties.buttonColor;
      return buttonColor;
    },
    color: function color(_ref7) {
      var buttonTextColor = _ref7.otherProperties.buttonTextColor;
      return buttonTextColor;
    },
    '&:hover': {
      backgroundColor: function backgroundColor(_ref8) {
        var buttonColor = _ref8.otherProperties.buttonColor;
        return buttonColor;
      }
    }
  }
};

// cookie key
var ACCEPTED_COOKIE_CONSENT = 'a_c_c';
var ACCEPTED_ESSENTIAL_COOKIE_CONSENT = 'a_e_c_c';
var CookieConsent = function (_Component) {
  _inherits(CookieConsent, _Component);
  function CookieConsent(props) {
    _classCallCheck(this, CookieConsent);
    var _this = _possibleConstructorReturn(this, (CookieConsent.__proto__ || Object.getPrototypeOf(CookieConsent)).call(this, props));
    _this.setCookie = function (name, value, expirationDays) {
      var events = _this.props.entities;
      var lang = _this.props.i18n.language;
      var eventUri = events[Object.keys(events)[0]].eventUri;
      var expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + expirationDate.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/' + lang + '/' + eventUri;
    };
    _this.getCookie = function (cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    };
    _this.handleClick = function (key) {
      _this.setCookie(key, true, 10);
      _this.setState({
        displayModal: false
      });
      if (key === ACCEPTED_ESSENTIAL_COOKIE_CONSENT) {
        var events = _this.props.entities;
        var gaId = !!events && events[Object.keys(events)[0]].googleAnalyticsTrackingCode;
        if (!!gaId && gaId !== '') window['ga-disable-' + gaId] = true;
        location.reload();
      }
    };
    _this.state = {
      displayModal: false
    };
    return _this;
  }

  // checks for the existence of a cookie that avoid to display the message after
  // it was accepted

  _createClass(CookieConsent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.getCookie(ACCEPTED_COOKIE_CONSENT) === "" && this.getCookie(ACCEPTED_ESSENTIAL_COOKIE_CONSENT) === "") this.setState({
        displayModal: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        value = _props.value,
        t = _props.t,
        otherProperties = _props.otherProperties,
        editable = _props.editable,
        cssProperties = _props.cssProperties;
      var secondaryButtonLabel = otherProperties.secondaryButtonLabel,
        buttonLabel = otherProperties.buttonLabel,
        principalText = otherProperties.principalText,
        privacyPolicyUrl = otherProperties.privacyPolicyUrl;
      return _react2.default.createElement('div', {
        className: classes.blockContainer
      }, !!editable && _react2.default.createElement('p', {
        className: classes.infoBlock
      }, t('cookie_consent.block_information')), !!this.state.displayModal && _react2.default.createElement('div', {
        className: classes.modalCookie,
        style: cssProperties
      }, _react2.default.createElement('p', {
        className: classes.infoCookies
      }, !!principalText && principalText !== '' ? principalText : t('cookie_consent.explanation')), !!privacyPolicyUrl && privacyPolicyUrl !== '' && _react2.default.createElement('p', {
        className: classes.infoCookies
      }, _react2.default.createElement('a', {
        href: privacyPolicyUrl,
        target: '_blank'
      }, t('cookie_consent.privacy_policy'))), _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        onClick: function onClick() {
          return _this2.handleClick(ACCEPTED_COOKIE_CONSENT);
        },
        className: classes.button
      }, !!buttonLabel && buttonLabel !== '' ? buttonLabel : t('buttons.got_it')), _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        onClick: function onClick() {
          return _this2.handleClick(ACCEPTED_ESSENTIAL_COOKIE_CONSENT);
        },
        className: classes.button
      }, !!secondaryButtonLabel && secondaryButtonLabel !== '' ? secondaryButtonLabel : t('buttons.onlyEssential'))));
    }
  }]);
  return CookieConsent;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(CookieConsent));